/**
 * aggregator-report-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AggVariable } from "../../../aggregation/typed-parameter";
import { AggregationDataType } from "../../../common/data/data-types";
import { SubjectContextType, KnownSubjectContextTypes }
  from "../../../subjects/subject-context-type";

import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

import { ActivityProgressWithAnswer }
  from "app/server/messages/aggregation/activity-progress";

/**
 * An {@link AggregatorReportResponse} carries the results of an aggregator's
 * (completed) execution, including any data, statistics, analyses, and links
 * as defined by the aggregator that was selected. The response also contains
 * some metrics about the execution process itself.
 */
@validateFor(MessageTag.RSP_AGGREGATOR_REPORT)
export class AggregatorReportResponse extends IncomingMessage
  implements ActivityProgressWithAnswer
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_AGGREGATOR_REPORT;

  @validateOpaqueID()
  public aggregationId : number;
  @validateOpaqueID()
  public groupId : number;
  @validateAs("string")
  public aggregator : string;

  @validateAs({enum: Object.values(KnownSubjectContextTypes)})
  public subjectContextType : SubjectContextType;

  @validateAs("string", true, undefined)
  public variable? : string;

  @validateAs("integer")
  public viable : number;
  @validateAs("integer")
  public unanswered : number;
  @validateAs("integer")
  public processed : number;
  @validateAs("integer")
  public rejected : number;

  @validateAs("integer")
  public start : number;
  @validateAs("integer")
  public ended : number;
  @validateAs("integer")
  public duration : number;

  @validateAs({array: "object"}) // TODO: improve
  public results : AggVariable[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/aggregator-report-response.ts